function isSameDay(d1: Date, d2: Date) {
    return d1.getFullYear() === d2.getFullYear() &&
        d1.getDate() === d2.getDate() &&
        d1.getMonth() === d2.getMonth();
}

export function parseDateStringToDate(dateStr: string): Date {
    const parts = dateStr.split("-");

    if (parts.length !== 3) throw new Error("Expecting format of 'YYYY-MM-DD'. Unable to parse date string with value = " + dateStr);

    const year = +parts[0];
    const month = +parts[1];
    const day = +parts[2];

    return new Date(year, month - 1, day);
}

export function isWeekend(date: Date) {
    const day = date.getDay();
    // 0 - sunday, 6 - saturday
    return day === 0 || day === 6;
}

export function isHoliday(holidays: Array<Date>, date: Date) {
    let result = false;

    for (let i = 0; i < holidays.length; i++) {
        if (isSameDay(holidays[i], date)) {
            result = true;
            break;
        }
    }

    return result;
}